var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { BackrsChip } from '@backrs_ui/common-ui/src/atoms/BackrsChip';
import { BackrsIconRow } from '@backrs_ui/common-ui/src/atoms/BackrsIconRow';
import { FitExplainer } from '@backrs_ui/common-ui/src/atoms/FitExplainer';
import { NUGGET_THEMES } from '@backrs_ui/common-ui/src/models/nugget';
import { Box, Typography, Tooltip } from '@mui/material';
var DIALOG_NUGGET_STRINGS = appStrings.modules.nugget.dialogNuggetActions;
function handleShareWithNavigator(shareParams) {
    return __awaiter(this, void 0, void 0, function () {
        var title, text, url, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!navigator.share) return [3, 2];
                    title = shareParams.title, text = shareParams.text, url = shareParams.url;
                    return [4, navigator.share({
                            title: title,
                            text: text,
                            url: url,
                        })];
                case 1:
                    _a.sent();
                    if (shareParams.afterShare) {
                        shareParams.afterShare();
                    }
                    _a.label = 2;
                case 2: return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    });
}
export var DialogNuggetHeader = function (_a) {
    var title = _a.title, titleOnClick = _a.titleOnClick, subTitle = _a.subTitle, columnCategory = _a.columnCategory, saveToLibrary = _a.saveToLibrary, shareParams = _a.shareParams, markAsDone = _a.markAsDone, customMenuActions = _a.customMenuActions, hasCompletedNugget = _a.hasCompletedNugget, hasBookmarkedNugget = _a.hasBookmarkedNugget, fit = _a.fit, fitExplainerOnClick = _a.fitExplainerOnClick, fitExplainerText = _a.fitExplainerText, user = _a.user;
    var _b = useState(false), showCopySuccess = _b[0], setShowCopySuccess = _b[1];
    var areThereMenuActions = saveToLibrary || shareParams || markAsDone || (customMenuActions === null || customMenuActions === void 0 ? void 0 : customMenuActions.length);
    var handleCopyLink = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shareParams) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, navigator.clipboard.writeText(shareParams.url)];
                case 2:
                    _a.sent();
                    setShowCopySuccess(true);
                    setTimeout(function () {
                        setShowCopySuccess(false);
                    }, 1500);
                    return [3, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Failed to copy link:', error_2);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    return (_jsxs(Box, { children: [_jsxs(Box, { sx: containerStyle, children: [_jsxs(Box, { sx: dialogNuggetHeaderStyle, children: [columnCategory && (_jsx(Box, { sx: chipContainer, children: _jsx(BackrsChip, { label: columnCategory, variant: { type: 'LARGE_TEXT', backgroundColor: 'BLUE' } }) })), _jsx(Typography, { sx: __assign(__assign({}, titleStyle), { cursor: titleOnClick ? 'pointer' : 'default' }), onClick: titleOnClick, children: title }), fit && (_jsx(FitExplainer, { fit: fit, fitExplainerOnClick: fitExplainerOnClick, fitExplainerText: fitExplainerText, disabled: !user })), _jsx(Typography, { sx: subTitleStyle, children: subTitle })] }), _jsx(Box, { children: areThereMenuActions && (_jsxs(Box, { sx: actionContainerStyle, children: [!!saveToLibrary && (_jsx(BackrsIconRow, { icon: hasBookmarkedNugget ? 'IconBookmarkFilled' : 'IconBookmark', text: DIALOG_NUGGET_STRINGS.bookmark, onClick: saveToLibrary })), !!shareParams && (_jsxs(_Fragment, { children: [_jsx(BackrsIconRow, { icon: "IconSend", text: DIALOG_NUGGET_STRINGS.share, onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4, handleShareWithNavigator(shareParams)];
                                                    case 1: return [2, _a.sent()];
                                                }
                                            }); }); } }), _jsx(Tooltip, { open: showCopySuccess, title: DIALOG_NUGGET_STRINGS.linkCopied, placement: "right", arrow: true, componentsProps: {
                                                popper: {
                                                    sx: linkCopiedPopperSx,
                                                },
                                            }, children: _jsx(Box, { children: _jsx(BackrsIconRow, { icon: "IconCopy", text: DIALOG_NUGGET_STRINGS.copyLink, onClick: handleCopyLink }) }) })] })), !!markAsDone && (_jsx(BackrsIconRow, { icon: hasCompletedNugget ? 'IconChecked' : 'IconUnchecked', text: columnCategory === NUGGET_THEMES.GROW_BY_DOING
                                        ? DIALOG_NUGGET_STRINGS.markDone
                                        : DIALOG_NUGGET_STRINGS.markComplete, onClick: markAsDone })), customMenuActions === null || customMenuActions === void 0 ? void 0 : customMenuActions.map(function (action) { return (_jsx(BackrsIconRow, { icon: action.icon, text: action.text, onClick: action.onClick }, action.text)); })] })) })] }), _jsx(Typography, { sx: smallScreenTitleStyle, children: title }), _jsx(Typography, { sx: smallScreenSubTitleStyle, children: subTitle })] }));
};
var containerStyle = {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 2,
    display: 'flex',
    '@media (max-width: 756px)': {
        flexDirection: 'column',
        gap: 1,
    },
};
var dialogNuggetHeaderStyle = {
    display: 'flex',
    flexDirection: 'column',
    mt: 3,
    minWidth: 400,
    '@media (max-width: 1000px)': {
        width: 600,
    },
    '@media (max-width: 756px)': {
        width: 100,
        minWidth: 100,
        flexDirection: 'row',
    },
};
var chipContainer = {
    mb: 2,
    '@media (max-width: 756px)': {
        mt: 1,
    },
};
var titleStyle = {
    fontFamily: 'Sarabun',
    fontSize: '32px',
    fontWeight: 700,
    minHeight: '36px',
    lineHeight: '32px',
    '@media (max-width: 756px)': {
        display: 'none',
    },
};
var smallScreenTitleStyle = {
    fontFamily: 'Sarabun',
    fontWeight: 700,
    minHeight: '36px',
    display: 'none',
    fontSize: '24px',
    lineHeight: '32px',
    '@media (max-width: 756px)': {
        display: 'block',
    },
};
var subTitleStyle = {
    fontFamily: 'Sarabun',
    fontSize: '24px',
    fontWeight: 400,
    display: 'block',
    '@media (max-width: 756px)': {
        display: 'none',
    },
};
var smallScreenSubTitleStyle = {
    fontFamily: 'Sarabun',
    fontSize: '20px',
    fontWeight: 400,
    display: 'none',
    '@media (max-width: 756px)': {
        display: 'block',
    },
};
var actionContainerStyle = {
    borderRadius: '0px 0px 4px 4px',
    px: 3,
    pt: 2,
    pb: 2,
    gap: 2,
    flexDirection: 'column',
    display: 'flex',
    minWidth: 170,
    backgroundColor: appColors.color.blue4,
    '@media (max-width: 756px)': {
        mb: 2,
    },
};
var linkCopiedPopperSx = {
    zIndex: 99999999999999,
};
